import { Component, Inject, OnInit } from '@angular/core';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from "@angular/material/dialog";

import { catchError, throwError } from 'rxjs';
import { NavBarComponent } from 'src/app/nav-bar/nav-bar.component';
import { SampleService } from 'src/app/services/sample.service';



import dayjs from "dayjs";
import { SoftTissueSampleModel } from 'src/app/models/soft-tissue-sample-model';
import { AddEditSoftTissueSampleComponent } from '../add-edit-soft-tissue-sample/add-edit-soft-tissue-sample.component';
import { DeleteSampleComponent } from '../../delete-sample/delete-sample.component';
import { NewDeletePinComponent } from '../../pin-rework-dialogs/new-delete-pin/new-delete-pin.component';
import {GrowthStageModel} from "../../../models/growth-stage";
import {PinManagerService} from "../../../services/pin-manager.service";
import {SeasonManagerService} from "../../../services/season-manager.service";
import { sample } from 'node_modules/cypress/types/lodash';


@Component({
    selector: 'app-leaf-pin-samples',
    templateUrl: './soft-tissue-pin-samples.component.html',
    styleUrls: ['./soft-tissue-pin-samples.component.css'],
    standalone: false
})
export class SoftTissuePinSamplesComponent implements OnInit{

  samples:SoftTissueSampleModel[] = [];


  tenantId = this.data.tenantId;
  userId = this.data.userId;

  dateStringFormatting = 'YYYY-MM-DD' + '  ' + 'hh:mm:ss'; 
  placeholder: string = "-";

  protected readonly dayjs = dayjs;
  growthStages: GrowthStageModel[] = [];

  pinObj = {
    pinTypeId: this.data.pinTypeId,
    date: this.data.date,
    lat: this.data.lat,
    lng: this.data.lng,
    farm: this.data.farm,
    field: this.data.field,
    fieldId: this.data.fieldId,
    creatingUser: this.data.creatingUser,
    pinId:  this.data.pinId,
    pinDescription: this.data?.pinDescription,
    is_completed: this.data?.isCompleted
  }

  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
      public deletePinDialog: MatDialog,
      public addSampleDialog: MatDialog,
      public closePinDialog: MatDialogRef<SoftTissuePinSamplesComponent>,
      private sampleService: SampleService,
      public nav: NavBarComponent,
      public pinManagerService: PinManagerService,
      public seasonManagerService: SeasonManagerService
  ) {
    this.closePinDialog.backdropClick().subscribe(() => {
      this.close();
    });
  }
  ngOnInit(): void {
    this.getFieldDetails();
    this.nav.toggleLoading(true);
    this.populateSampleList();
  }

  getFieldDetails() {
    this.seasonManagerService.getDetailsOfFieldById(Number(this.data.fieldId)).subscribe((res) => {
      this.getGrowthStageMetaData(res?.detail?.currentCrop)
    })
  }

  getGrowthStageMetaData(cropId: number) {
    this.pinManagerService.getGrowthStageMetaData(cropId).subscribe((res: GrowthStageModel[]) => {
      this.growthStages = res;
    })
  }

  close(): void {
    if(this.samples?.length > 0) {
      this.pinObj.is_completed = this.samples.every(s => s?.isCompleted);
      this.checkSampleName(this.samples[0]?.name);
    } else {
      this.pinObj.is_completed = false;
      this.checkSampleName('');
    }
    
    this.closePinDialog.close(this.pinObj);
  }

  checkSampleName(sampleName: string) {
    if(sampleName.length > 0) {
      this.pinObj.pinDescription = sampleName;
    } else {
      this.pinObj.pinDescription = 'Soft Tissue';
    }
  }


  populateSampleList(){
    this.sampleService.getSoftTissueSamplesListByPinId(this.pinObj.pinId).pipe(
        catchError(error =>{
          console.error();
          return throwError(()=> error);
        })
    ).subscribe({
      next: (response) => {
        this.samples = response;
        this.nav.toggleLoading(false);
      },
      error: () => {
        this.nav.toggleLoading(false);
      }
    })
   
  }

  openAddSampleDialog() {

    const dialogRef = this.addSampleDialog.open(AddEditSoftTissueSampleComponent, {

      data:{
        pinId: this.pinObj.pinId,
        userId: this.userId,
        tenantId: this.tenantId,
        isAddNewSapleMode: true,
        isEditSampleMode: false,
        growthStages: this.growthStages
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      setTimeout(()=>{
        this.populateSampleList();
      },500)
    });

  }

  openEditSampleDialog(sampleItem) {

    const dialogRef = this.addSampleDialog.open(AddEditSoftTissueSampleComponent, {

      data:{
        pinId: this.pinObj.pinId,
        userId: this.data.userId,
        tenantId: this.data.tenantId,
        isEditSampleMode:true,
        isAddNewSapleMode: false,
        sampleId: sampleItem.id,
        linkedGroup: sampleItem.group,
        sampleName: sampleItem.name,
        bagNumber: sampleItem.bagNumber,
        plantPart: sampleItem.softTissue.plantPartId,
        cropAge: sampleItem.softTissue.cropAge,
        note: sampleItem.note,
        pinCropGrowthStageLinkId: sampleItem?.softTissue?.pinCropGrowthStageLinkId,
        growthStages: this.growthStages,
        isCompleted: sampleItem.isCompleted,
        seasonFieldDetailId: sampleItem.seasonFieldDetailId
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      setTimeout(()=>{
        this.populateSampleList();
      },500)
    });

  }
  
  openDeleteSampleDialog(sampleItem) {

    const dialogRef = this.addSampleDialog.open(DeleteSampleComponent, {

      data:{
        sampleId: sampleItem.id,
        isBulkDelete: false
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      setTimeout(()=>{
        this.populateSampleList();

      },500)
    });

  }


  openDeletePinDialog() {

    const dialogRef = this.deletePinDialog.open(NewDeletePinComponent, {

      data:{
        pinId: this.pinObj.pinId
      }
    });


    dialogRef.afterClosed().subscribe(result => {
      if(result.option === 'delete'){
        this.closePinDialog.close();
       }
    });
  }
}
